export const fonts = {
  montserrat: {
    regular: 'Montserrat',
    bold: 'MontserratBold',
    italic: 'MontserratItalic',
    italicBold: 'MontserratBoldItalic',
    light: 'MontserratLight',
  },
}
